"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var AbstractSlide = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(AbstractSlide, _window$AbstractEleme);

    var _super = _createSuper(AbstractSlide);

    function AbstractSlide(id, options) {
      var _this;

      _classCallCheck(this, AbstractSlide);

      /*
          The Filter effect is enabled
              - only in the desktop
              - if the are media contents (images or video)
              - if it's an interactive element OR mode == 'auto'
      */
      var FX_ENABLED = window.Detectizr.device.type == "desktop" && (options.$domElement.find("img").length || options.$domElement.find("video").length) && (options.$domElement.is("a") || options.$domElement.find(".slide-desc .slide-desc-inner .btn").length || options.slideFX && options.slideFX.mode == "auto");
      var OPTIONS_MANDATORY = {
        watchResize: Detectizr.browser.name == "edge",
        watchResizeTimeout: 300
      };
      options = $.extend(true, _.clone(options), OPTIONS_MANDATORY);
      var OPTIONS_DEFAULT = {
        scrollWatcher: options.scrollWatcher !== false ? {
          thresholdStep: 2
        } : false,
        slideFX: FX_ENABLED ? {
          mode: null // null: manual trigger, auto, interactive

        } : null,
        onPointerEnter: function onPointerEnter() {},
        onPointerLeave: function onPointerLeave() {}
      };
      options = $.extend(true, OPTIONS_DEFAULT, _.clone(options));
      _this = _super.call(this, id, options);
      _this.$mediaWrapper = _this.$domElement.find(".media-wrapper");
      _this.$slideDesc = _this.$domElement.find(".slide-desc");
      _this.$media = _this.$mediaWrapper.find("> *");

      if (_this.$domElement.is("a")) {
        _this.$linkAnchor = _this.$domElement;
      } else if (_this.$domElement.find(".slide-desc .slide-desc-inner .btn").length) {
        _this.$linkAnchor = _this.$domElement.find(".slide-desc .slide-desc-inner .btn");
      } else {
        _this.$linkAnchor = null;
      }

      if (_this.options.slideFX) {
        /* this.slideHoverFX = new window.SlideFX(null, {
            $domElement: this.$mediaWrapper,
            mode: this.options.slideFX.mode
        });
        this.slideHoverFX.pause(); */
      }

      return _this;
    }

    _createClass(AbstractSlide, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.video = this.$domElement.find("video")[0];

        if (this.video) {
          $(this.video).one("loadedmetadata", function (event) {
            $(event.delegateTarget).attr("data-video-width", _this2.video.videoWidth).attr("data-video-height", _this2.video.videoHeight);

            _this2.resizeTimeoutHandler();
          });
          this.$domElement.on(window.AbstractElement.EL_SCROLL_WATCHER, function (event, el, scrollEvent, entry) {
            event.stopPropagation();

            if (scrollEvent.match(window.ScrollWatcher.IS_IN_VIEWPORT + "|" + window.ScrollWatcher.IS_FULLY_IN_VIEWPORT)) {
              window.clearTimeout(_this2._playTimeout);
              _this2._playTimeout = window.setTimeout(function () {
                _this2.playVideo();
              }, 150);
            } else if (scrollEvent.match(window.ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT)) {
              _this2.pauseVideo();
            }
          });
        }

        if (this.$linkAnchor) {
          this.$linkAnchor.on("pointerenter", this.onPointerEnter.bind(this));
          this.$linkAnchor.on("pointerleave", this.onPointerLeave.bind(this));
        }
        /* if (this.slideHoverFX) {
            if (this.options.slideFX.mode == "auto") {
                this.$domElement.on(window.AbstractElement.EL_SCROLL_WATCHER, (event, el, scrollEvent, entry) => {
                    event.stopPropagation();
                    if (scrollEvent.match(window.ScrollWatcher.IS_IN_VIEWPORT + "|" + window.ScrollWatcher.IS_FULLY_IN_VIEWPORT)) {
                        this.slideHoverFX.play();
                    } else if (scrollEvent.match(window.ScrollWatcher.HAS_FULLY_EXIT_VIEWPORT)) {
                        this.slideHoverFX.pause();
                    }
                });
            }
            this.slideHoverFX.init();
        } */


        _get(_getPrototypeOf(AbstractSlide.prototype), "init", this).call(this);

        this.resizeTimeoutHandler();
      }
    }, {
      key: "playVideo",
      value: function playVideo() {
        if (this.video) this.video.play();
      }
    }, {
      key: "pauseVideo",
      value: function pauseVideo() {
        window.clearTimeout(this._playTimeout);
        if (this.video) this.video.pause();
      }
    }, {
      key: "dispose",
      value: function dispose() {
        /* if (this.slideHoverFX) {
            this.slideHoverFX.dispose();
            this.slideHoverFX = null;
        } */
        if (this.$linkAnchor) {
          this.$linkAnchor.off("pointerenter");
          this.$linkAnchor.off("pointerleave");
        }

        this.pauseVideo();

        _get(_getPrototypeOf(AbstractSlide.prototype), "dispose", this).call(this);
      }
    }, {
      key: "onPointerEnter",
      value: function onPointerEnter(event) {
        event.stopPropagation();
        this.options.onPointerEnter.bind(this)();
        /* manual trigger */

        /* if (this.slideHoverFX && !this.options.slideFX.mode) {
            this.slideHoverFX.play();
        } */
      }
    }, {
      key: "onPointerLeave",
      value: function onPointerLeave(event) {
        event.stopPropagation();
        this.options.onPointerLeave.bind(this)();
        /* manual trigger */

        /* if (this.slideHoverFX && !this.options.slideFX.mode) {
            this.slideHoverFX.pause();
        } */
      }
    }, {
      key: "resizeTimeoutHandler",
      value: function resizeTimeoutHandler() {
        var $v = $(this.video);

        if (Detectizr.browser.name == "edge" && this.video && $v.attr("data-video-width")) {
          var SIZE = ObjectFitResizer.fit($v.parent().width(), $v.parent().height(), parseInt($v.attr("data-video-width")), parseInt($v.attr("data-video-height")), ObjectFitResizer.RESIZE_TYPE_COVER, true);
          $v.css({
            position: "absolute",
            width: SIZE.width,
            height: SIZE.height,
            left: SIZE.x,
            top: SIZE.y
          });
        }
      }
    }]);

    return AbstractSlide;
  }(window.AbstractElement);

  window.AbstractSlide = AbstractSlide;
})(window);
